export const required = (value) => !!value || 'Ce champ est requis';

export const minLength = (length) => (value) =>
  value.length >= length || `Le champ doit contenir au moins ${length} caractères`;

export const email = (value) =>
  /.+@.+\..+/.test(value) || 'Email invalide';

export const passwordStrength = (value) =>
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(value) || 'Le mot de passe doit contenir au moins 8 caractères, avec des lettres et des chiffres';


